<template>

  <div>
    <gnetRecordHeader
      v-bind:object="'photo'"
      v-bind:title="title"
      
      v-bind:actions="headlineActions"
      v-bind:others="assegno.photos"
      v-on:click="actionClick($event)"
      v-on:other="removePhoto($event)"
    />

    <div class="slds-grid">
        <img v-if="!streaming" src="images/empty-photo.jpg" >
        <video style="width:100%" id="video" autoplay>Stream video non disponibile</video>
        <canvas id="canvas" style="display:none"></canvas>
    </div>
    <!--
        <div class="slds-grid" v-for="(device, index) in $store.state.devices" v-bind:key="device.label">
          {{index}}: {{device.deviceId}} - {{device.kind}} - {{device.label}} <br/>
        </div>
    -->
  </div>

</template>

<script>
import moment from 'moment'
import gnetRecordHeader from '../components/recordheader.vue'

export default {
  name: 'foto',
  components: {
    gnetRecordHeader
  },
  props: {
    assegno: Object,
    readonly: {
      type: Boolean,
      default: false
    },
  },
  data: function() {
    return { 
      title:'',
      streaming: false,
      video: {},
      width: undefined,
      height: undefined,
      canvas: {},
      headlineFields: [],
      headlineActions: []
    }
  },
  async created() {
  },
  mounted() {
    this.headlineFields.push( { value:'', label:'Numero', name: this.assegno.numero } );
    this.headlineFields.push( { value:'', label:'Data', name: this.assegno.data } );
    this.headlineFields.push( { value:'', label:'Importo', name: this.assegno.importo } );

    this.title=this.assegno.numero+ ' del '+this.assegno.data + ' € '+this.assegno.importo;
    this.headlineActions.push( { title:'Fotografa', name:'scatta' } );
    this.headlineActions.push( { title:'Fine', name:'fine' } );

    this.video = document.getElementById("video");
    this.canvas = document.getElementById('canvas');

    if(!this.readonly){
      if (navigator.mediaDevices) {
        var self=this;
        this.$store.dispatch('getDevices').then(function() {
          self.openStream();
        });
      }
    }
  },
  filters: {
    dataIta: function(v) {
      if (v) return new moment(v).format('DD/MM/YYYY')
      return v;
    }
  },
  beforeDestroy: function() {
      if (this.video)
      if (this.video.srcObject)
        this.video.srcObject.getVideoTracks().forEach(track => track.stop());
  },
  methods: {
    actionClick: function(action) {
      switch(action) {
        case 'scatta':
          console.log('takepicture')
          this.takepicture();
        break;
        case 'fine':
          console.log('closeStream')
          this.closeStream();
        break;
      }
      console.log(action);
    },
    closeStream: function() {
      console.log('closing stream');
      if (this.video)
      if (this.video.srcObject)
        this.video.srcObject.getVideoTracks().forEach(track => track.stop());
      this.$emit('cancel');
    },
    openStream: function() {
      try {
        var constraints={ video: { facingMode: 'environment' } };
        if (this.$store.state.deviceback) constraints.video= { deviceId: { exact: this.$store.state.deviceback } };

        var self=this;
        navigator.mediaDevices.getUserMedia(constraints).then(function(stream) {
          self.video.srcObject = stream;
          self.video.play();
          console.log("Received local video stream");
          self.streaming=true;
        })
      } catch (error) {
        console.log(`getUserMedia error: ${error}`);
      }
    },
    takepicture: function() {
      var context = this.canvas.getContext('2d');
      this.canvas.width = this.video.videoWidth;
      this.canvas.height = this.video.videoHeight;
      //this.canvas.height = 360;
      /*
      this.video.width = 480;
      this.video.height = 360;
      */
       console.log(this.video.videoWidth);
       console.log(this.video.videoHeight);
      context.drawImage(this.video, 0, 0, this.video.videoWidth, this.video.videoHeight);
      //this.video.width = this.width;
      //this.video.height = this.height;
      var data = this.canvas.toDataURL('image/png');
      //console.log(data);
      this.assegno.photos.push({ progress:0, id: this.assegno.photos.length, data: data });
    },
    removePhoto: function(index) {
      if(!this.readonly){
        this.assegno.photos.splice(index, 1);
      }
    },
  }
}
</script>
